/** @format */

import {ChartIds} from '../models/chartIds';

const isStubChartId = (id: ChartIds): boolean => {
  return id.startsWith('stub_');
};

export default isStubChartId;
